export const SIDE_NAV_WIDTH = 256;
export const SIDE_NAV_COLLAPSED_WIDTH = 58;
export const PROFILE_MENU_WIDTH = 254;
export const DEFER_SEARCH_TIMEOUT = 400;
export const ITEMS_PAGE_LIMIT = 15;
export const ITEMS_TABLE_PAGE_LIMIT = 20;
export const IS_PROD = import.meta.env.PROD;

export const ENG_TO_ESP_MONTH = {
  January: 'Enero',
  February: 'Febrero',
  March: 'Marzo',
  April: 'Abril',
  May: 'Mayo',
  June: 'Junio',
  July: 'Julio',
  August: 'Agosto',
  September: 'Septiembre',
  October: 'Octubre',
  November: 'Noviembre',
  December: 'Diciembre',
};
